import {http, onSuccess, onFail} from './http';

export const getEpisodes = (streamId) =>
    http.get(`/api/cp/event/stream/${streamId}/episode`)
        .then(onSuccess, onFail);

export const getEpisode = (id) =>
    http.get(`/api/cp/event/stream/episode/${id}`)
        .then(onSuccess, onFail);

export const createEpisode = (streamId, data) =>
    http.post(`/api/cp/event/stream/${streamId}/episode`, data)
        .then(onSuccess, onFail);

export const updateEpisode = (id, data) =>
    http.post(`/api/cp/event/stream/episode/${id}`, data)
        .then(onSuccess, onFail);

export const deleteEpisode = (id) =>
    http.delete(`/api/cp/event/stream/episode/${id}`)
        .then(onSuccess, onFail);

export const clearEpisodesList = (id) =>
    http.delete(`/api/cp/event/stream/${id}/episode/clear`)
        .then(onSuccess, onFail);
